















import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action} from "vuex-class";

@Component({})
export default class MemberLoanProcessGrid extends FeedbackComponent {

  @Prop(String) memberIdNum!: string;

  @Action('getLoanProcess', StoreNamespace.CUSTOMER_SERVICE) getLoanProcess: any;

  private columns: GridColumn[] = [];


  mounted() {
    this.initColumns();

    if (this.memberIdNum) {
      this.getLoanProcess({
        pathVariable: this.memberIdNum,
        requestorCallback: this
      })
    }
  }

  private initColumns(): void {
    this.columns.push({property: 'loanStatusType.value', header: 'requestManagement.requestStatus'} as GridColumn)
    this.columns.push({
      property: 'requestType',
      header: 'requestManagement.requestType',
      hideSorting: true
    } as GridColumn)
    this.columns.push({property: 'dateCreated', header: 'requestManagement.requestSubmitDate'} as GridColumn)
    this.columns.push({property: 'memberIdNum', header: 'requestManagement.idNumber'} as GridColumn)
    this.columns.push({property: 'fullName', header: 'requestManagement.fullName', hideSorting: true} as GridColumn)
    this.columns.push({property: 'accountNum', header: 'requestManagement.accountNumber'} as GridColumn)
    this.columns.push({
      property: 'loanAmount',
      header: 'requestManagement.loanOrWithdrawalRequestedAmount', hideSorting: true
    } as GridColumn)
    this.columns.push({property: 'grace', header: 'requestManagement.interest', hideSorting: true} as GridColumn)
    this.columns.push({
      property: 'loanType.value',
      header: 'requestManagement.loanType',
      hideSorting: true
    } as GridColumn)
    this.columns.push({property: 'loanTime', header: 'requestManagement.refundPeriod', hideSorting: true} as GridColumn)
    this.columns.push({
      property: 'ratingType.value',
      header: 'requestManagement.rating',
      hideSorting: true
    } as GridColumn)
  }


  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'findMembersOrEmployersFor/loanProcess':
        data.hasMore = false;
        this.$emit('successResults', data)
        break;
    }
  }
}

